import Page from "components/Page"
import Projects from "components/Projects"
import { FEATURED_PROJECTS } from "config"
import usePageMeta from "hooks/usePageMeta"
import { getFeaturedProjectPreviewImage } from "utils/socialPreview"

const ProjectsPage = () => {
  usePageMeta(
    "Work — r4v3n",
    "Generative art projects and 1/1 works by r4v3n.",
    getFeaturedProjectPreviewImage(FEATURED_PROJECTS[0]),
    "/projects",
  )
  return (
    <Page>
      <Projects/>
    </Page>
  )
}

export default ProjectsPage
